"use client"

import dynamic from "next/dynamic"
import { LazyMotion, domAnimation } from "framer-motion"
import { Navbar, HeroSection, LogosStrip, AboutSection } from './components'
const ServicesSection = dynamic(() => import('./components/services-section').then(m => ({ default: m.ServicesSection })))
const CostCalculator = dynamic(() => import('./components/cost-calculator').then(m => ({ default: m.CostCalculator })))
const ProcessSection = dynamic(() => import('./components/process-section').then(m => ({ default: m.ProcessSection })))
const PortfolioSection = dynamic(() => import('./components/portfolio-section').then(m => ({ default: m.PortfolioSection })))
const TestimonialsSection = dynamic(() => import('./components/testimonials-section').then(m => ({ default: m.TestimonialsSection })))
const PricingSection = dynamic(() => import('./components/pricing-section').then(m => ({ default: m.PricingSection })))
const TeamSection = dynamic(() => import('./components/team-section').then(m => ({ default: m.TeamSection })))
const FaqSection = dynamic(() => import('./components/faq-section').then(m => ({ default: m.FaqSection })))
const ContactSection = dynamic(() => import('./components/contact-section').then(m => ({ default: m.ContactSection })))
const Footer = dynamic(() => import('./components/footer').then(m => ({ default: m.Footer })))

export function HomePage() {
    return (
        <LazyMotion features={domAnimation}>
            <main className="relative min-h-[100dvh] bg-background overflow-x-hidden">
                <Navbar />
                <HeroSection />
                <LogosStrip />
                <AboutSection />
                <ServicesSection />
                <CostCalculator />
                <ProcessSection />
                <PortfolioSection />
                <TestimonialsSection />
                <PricingSection />
                <TeamSection />
                <FaqSection />
                <ContactSection />
                <Footer />
            </main>
        </LazyMotion>
    )
}
